import { RootState } from "../../../app/store/store";

export const selectfilterStock = (state: RootState) => state.filterStock;
